export default {"src":"/_next/static/media/twitter-icon.72657f19.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};